import { createElement } from 'react';
const Image = ({ imgSrc, onClick, children, ...otherProps }) => {
    const _otherProps = otherProps || {};
    return (createElement("div", { className: "image", ..._otherProps, onClick: onClick }, imgSrc ? createElement("img", { src: imgSrc, alt: "" }) : createElement("div", null, "\u6682\u65E0\u6570\u636E")));
};
Image.displayName = 'Image';
export default Image;
